import { render, staticRenderFns } from "./SaleInvoiceReport.vue?vue&type=template&id=3c135cd6&"
import script from "./SaleInvoiceReport.vue?vue&type=script&lang=js&"
export * from "./SaleInvoiceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports